import React, { useState, useEffect } from "react";
import NumberFormat from "react-number-format";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import classNames from "classnames";
import { Controller } from "react-hook-form";
import IntlCurrencyInput from "react-intl-currency-input";

export default function InputNumber({
  label,
  name,
  type,
  placeholder,
  adornment,
  required,
  valueAsNumber,
  allowNegative,
  control,
  defaultValue,
  error,
  ...restProps
}) {
  return (
    <div className="__auth-input-group">
      <label htmlFor={name} className="__auth-label">
        {label}
        {required && <span className="__auth-input-required">*</span>}
        {adornment}
      </label>
      <Controller
        name={name}
        control={control}
        defaultValue={defaultValue}
        render={({ field, onChange, value }) => (
          <IntlCurrencyInput
            currency="BRL"
            config={{
              locale: "pt-BR",
              formats: {
                number: {
                  BRL: {
                    style: "currency",
                    currency: "BRL",
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  },
                },
              },
            }}
            className="ant-input"
            type={type}
            className="__auth-input"
            id={name}
            placeholder={placeholder}
            {...field}
            {...restProps}
          />
        )}
      ></Controller>

      {error && (
        <div
          className={classNames("__auth-input-error", {
            "__auth-input-error-filled": error,
          })}
        >
          <ExclamationCircleOutlined className="__auth-input-error-icon" />
          {error}
        </div>
      )}
    </div>
  );
}
